import { css } from "@emotion/core";

export const tagsStyle = {
  tagsContainer: {
    display: "flex",
    flexWrap: "wrap"
  }
}

export const tagStyle = (isSelected: boolean, isMobile: boolean) => {
  const baseStyle = {
    backgroundColor: "#fff",
    padding: 10,
    borderRadius: 2,
    fontFamily: "BrandonTextWeb-Medium",
    color: "rgb(145, 151, 171)",
    fontSize: 13,
    display: "flex",
    alignItems: "center",
    cursor: "pointer",
    boxShadow: "0px 2px 5px 0px rgba(0, 0, 0, 0.05)",
    marginRight: 12,
    marginBottom: isMobile ? 8 : 0
  }

  if (isSelected) {
    baseStyle.color = "rgb(255, 49, 109)"
  }
  return baseStyle;
}

export const tagCheckboxStyle = (isSelected: boolean) => {
  const baseStyle: any = {
    height: 14,
    width: 14,
    marginRight: 8,
    border: "1px solid rgb(145, 151, 171)"
  }

  if (isSelected) {
    baseStyle.borderColor = "rgb(255, 49, 109)";
    baseStyle.backgroundColor = "rgb(255, 49, 109)";
    baseStyle.display = "flex";
    baseStyle.alignItems = "center";
    baseStyle.justifyContent = "center";
    baseStyle[":after"] = {
      content: "'✓'",
      color: "#fff",
      height: 14
    }
  }
  return baseStyle;
}